<div class="col-md-12">
    <h4 class="empty"><i class="i-style">You are not authorized...</i></h4>
</div>